import React, { useEffect, useState } from "react";

function Stats() {

    const [statsData, setStatsData] = useState([]);



    useEffect(() => {
        fetch('https://arnowillig.de/solar/getstats.php').then(res => res.json()).then((data) => {
            setStatsData(data.Data);
        });
    }, []);

    return (
        <table>
            <thead></thead>
            <tbody>
                <tr><td>Aktuell:</td><td>{statsData.PowerStr}</td></tr>
                <tr><td>Spitze:</td><td>{statsData.StrPeakPower}</td></tr>
                <tr><td>Heute:</td><td>{statsData.UnitEToday}</td></tr>
                <tr><td>Monat:</td><td>{statsData.UnitEMonth}</td></tr>
                <tr><td>Jahr:</td><td>{statsData.UnitEYear}</td></tr>
                <tr><td>Gesamt:</td><td>{statsData.UnitETotal}</td></tr>
                <tr><td>Ersparnis:</td><td>{statsData.StrIncome}</td></tr>
            </tbody>
        </table>
    );
}

export default Stats;
